import React from "react";
import Button from "@mui/material/Button";

const AuthBtn = ({
  text,
  className,
  onClick,
  style,
  btnColor,
  btnTextColor = "white",
  Icon,
  disabled,
  borderColor,
  endIcon,
  width,
}) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        width: "100%",
      }}
    >
      <Button
        variant="contained"
        className={`${className} ${
          btnColor ? btnColor : "GrdiantBtn border-0"
        } `}
        onClick={onClick}
        startIcon={Icon ? Icon : ""}
        endIcon={endIcon ? endIcon : ""}
        disabled={disabled ? disabled : false}
        sx={{
          height: "40px",
          backgroundColor: btnColor,
          color: btnTextColor,
          textTransform: "none",
          border: 1,
          borderColor: borderColor ? borderColor : btnColor,
          borderRadius: "8px",
          "&:hover": {
            backgroundColor: btnColor, // or any other desired color
          },
          width: width ? width : "auto",
        }}
        style={{ style }}
      >
        <span
          className=""
          style={{ color:"#fff", fontSize: "16px", fontFamily: "PoppinsMedium" }}
        >
          {text}
        </span>
      </Button>
    </div>
  );
};

export default AuthBtn;
